import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface ITerminalAddRequest {
  merchantId: number;
  terminalId: string | number;
}

async function addTerminal(data: ITerminalAddRequest): Promise<any> {
  try {
    const response = await axiosInstance.post(`Terminal/Add?merchantId=${data.merchantId}&terminalId=${data.terminalId}`);
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddTerminal() {
  return useMutation<any, Error, ITerminalAddRequest>((variables) =>
    addTerminal(variables)
  );
}
